// $('a').each(function () {
//   // Check if the link is external
//   if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://www.Misshaus.com') {
//     // Create a span element with warning text
//     var warningSpan = $('<span class="visually-hidden">: This link will open in a new tab.</span>');
//     // Set attributes for accessibility
//     $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
//     // Append the warning span inside the link
//     $(this).append(warningSpan);
//   }
// });


// External Links Warning
// External Links Warning



$('br').attr('aria-hidden', 'true');


// document.addEventListener("DOMContentLoaded", function () {
//   const dropdownItems = document.querySelectorAll(".menu-lv-item.dropdown > a");

//   dropdownItems.forEach((item) => {
//     item.addEventListener("click", function (e) {
//       e.preventDefault(); // link turant open na ho
//       const parent = this.parentElement;

//       // Baaki dropdowns close kar do
//       document.querySelectorAll(".menu-lv-item.dropdown").forEach((el) => {
//         if (el !== parent) {
//           el.classList.remove("open");
//         }
//       });

//       // Is wale dropdown ko toggle karo
//       parent.classList.toggle("open");
//     });
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const dropdownLinks = document.querySelectorAll(".menu-lv-item.dropdown > a");

//   dropdownLinks.forEach(link => {
//     const submenu = document.getElementById(link.getAttribute("aria-controls"));

//     link.addEventListener("click", function (e) {
//       e.preventDefault();

//       const isExpanded = this.getAttribute("aria-expanded") === "true";

//       // Sab dropdowns close karo
//       document.querySelectorAll(".menu-lv-item.dropdown > a").forEach(l => {
//         l.setAttribute("aria-expanded", "false");
//         const sm = document.getElementById(l.getAttribute("aria-controls"));
//         if (sm) sm.hidden = true;
//       });

//       // Current toggle karo
//       if (!isExpanded) {
//         this.setAttribute("aria-expanded", "true");
//         submenu.hidden = false;
//       }
//     });
//   });
// });



// Email and phone number labels
// document.addEventListener('DOMContentLoaded', () => {
//   const handleContactLinks = () => {
//     const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
 
//     links.forEach(link => {
//       const href = link.getAttribute('href');
//       const linkText = link.textContent.trim();
 
//       if (href.startsWith('mailto:')) {
//         link.setAttribute('aria-label', `Email Address: ${linkText}`);
//       } else if (href.startsWith('tel:')) {
//         link.setAttribute('aria-label', `Phone number: ${linkText}`);
//       }
//     });
//   };
 
//   handleContactLinks();
// });


///add aria-hidden="true" on all br tags
 
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('br').forEach(function(br) {
    br.setAttribute('aria-hidden', 'true');
  });
});





$('#HeaderNavigation li.dropdown > a').removeAttr('href').attr('role','button').attr('tabindex','0').attr('aria-expanded','false');
$('#HeaderNavigation li.dropdown .header__submenu .menu-lv-item .site-nav-list-dropdown > a').removeAttr('href').attr('role','button').attr('tabindex','0').attr('aria-expanded','false');
$("#HeaderNavigation li.dropdown").on("click keypress", function(e) {
            e.stopPropagation();
            
             if (e.type === 'keypress' && e.which !== 13) {
                return;
            }
    
            const $dropdownLink = $(this).find("a").first();
    
            if ($dropdownLink.attr("aria-expanded") === "false") {
    
                $("li.menu-item-has-children > a").attr("aria-expanded", "false");
                $("li.menu-item-has-children").removeClass("active");
    
                $dropdownLink.attr("aria-expanded", "true");
                $(this).addClass("active");
    
            } else {
                
                $dropdownLink.attr("aria-expanded", "false");
                $(this).removeClass("active");
    
            }
        });

$(document).on("keydown", function(e) {
  if (e.key === "Escape" || e.keyCode === 27) {
    const $activeDropdown = $("#HeaderNavigation li.dropdown.active");

    if ($activeDropdown.length) {
      const $dropdownLink = $activeDropdown.children("a").first();

      // Close dropdown
      $dropdownLink.attr("aria-expanded", "false");
      $activeDropdown.removeClass("active");

      // Return focus to the anchor
      $dropdownLink.trigger("focus");
    }
  }
});

$(document).focusin(function(event) {
  var $closestDropdown = $(event.target).closest("li.dropdown");

  $("li.dropdown").not($closestDropdown).each(function() {
    if ($closestDropdown.closest(this).length === 0) {
      $(this).removeClass("active");
      $(this).find(".header__menu-item").attr("aria-expanded", "false");
    }
  });
});
